import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';

import { IFormAddressConfiguration } from '../../../../../modules/formAddress/types/formAddressTypes';
import { IPersonalDataInfo } from '../types/info';
import { IPersonalDataDocType } from '../types/meta';
import { IPersonalDataDocTypeResponse } from './meta';

export interface IPersonalDataInfoResponse {
    address: IFormAddressConfiguration;                 // Адрес регистрации
    document: {
        dateOfIssue?: string;                           // Дата выдачи
        divisionCode?: string;                          // Код подразделения
        number?: string;                                // Номер документа
        providedByOrganization?: string;                // Кем выдан
        series?: string;                                // Серия документа
        type: IPersonalDataDocTypeResponse;             // Тип документа
        validFor?: string;                              // Валиден до
    };
    personalData?: {
        birthDate?: string;                             // Дата рождения
        birthPlace?: string;                            // Место рождения
        email?: string;                                 // Электронный адрес
        fullName?: string;                              // ФИО
        nationalityInfo?: {                             // Страна гражданства
            airAddress: {
                addressId: string;
                addressString: string;
            };
        };
    };
}

export const personalDataInfoMapping =
    ({ personalData, document, ...response }: IPersonalDataInfoResponse,
     defaultDocument?: IPersonalDataDocType,
    ): IPersonalDataInfo => {

        return {
            ...response,
            document: document
                ? { ...document, type: { label: document.type.name, value: document.type.identificationTypeId } }
                : { type: { label: defaultDocument?.name ?? '', value: defaultDocument?.id ?? '' } },
            isEmpty: !Object.keys(pickBy(personalData, identity)).length
                && !Object.keys(pickBy(document, identity)).length,
            personalData: {
                ...(personalData || {}),
                nationalityInfo: personalData?.nationalityInfo?.airAddress,
            },
        };
    };
